export const SUPPORTED_LANGUAGES = ['en', 'ja'];

export const SET_LANGUAGE_MESSAGES = 'SET_LANGUAGE_MESSAGES';
